<template>
    <AuthStepBasicDialog :errorMessage="state.errorMessage" :successMessage="state.successMessage">




        <template #icon>
            <EmailIcon></EmailIcon>
        </template>



        <template #title>
            Verification link sent!
        </template>



        <template #description>
            <span class="opacity-60">We sent a verification link to </span>
            <span class="weight-600">{{ state.email }}</span>
            <br>
            <span class="opacity-60">Please check your email and click on the link to verify your account.</span>
        </template>




        <template #form>
            <div class="text-14 weight-500 text-center">
                <span class="opacity-60">Didn't receive the link? </span>
                <span class="pointer text-primary" @click="resendVerificationLink"
                    :class="{ 'disabled-text': resendDisabled }">
                    Click to resend
                    <template v-if="countdown > 0">
                        ({{ countdown }}s)
                    </template>
                </span>
            </div>
        </template>





    </AuthStepBasicDialog>
</template>










<script setup>
import authEvents from '@/Events/AuthDialog';
import EmailIcon from '@/icons/ResetPassword/Email.vue';
import { AuthService } from '@/api/services/AuthService';
import { provide, ref, onUnmounted, onMounted, reactive } from 'vue';
import AuthStepBasicDialog from '@/components/Auth/Common/Auth-Steps-Basic-Dialog.vue';




// control dialog visibility
const dialogVisible = ref(false);
provide('openDialog', dialogVisible);

const state = reactive({
    
    email: '',
    password: '',
    firstName: '',
    lastName: '',


    errorMessage: '',
    successMessage: '',
});








const countdown = ref(0);
const resendDisabled = ref(false);
let countdownInterval;

const startCountdown = () => {
    clearInterval(countdownInterval);
    countdown.value = 60;
    resendDisabled.value = true;
    countdownInterval = setInterval(() => {
        countdown.value--;
        if (countdown.value === 0) {
            clearInterval(countdownInterval);
            resendDisabled.value = false;
        }
    }, 1000);
};







const resendVerificationLink = async () => {
    if (resendDisabled.value) return;
    state.errorMessage = '';
    state.successMessage = '';

    try {
		const response = await AuthService.signup(state.firstName, state.lastName, state.email, state.password, state.recaptcha);
        if (response.success) {
            state.successMessage = 'Email sent successfully';
            startCountdown();
        } else {
            state.errorMessage = response.message;
        }
    } catch (error) {
        state.errorMessage = error.friendly_message;
    }
};







const signupVerificationEmailSent = async (signupData) => {
    openVerificationLinkSentDialog();
    
    
    state.email = signupData.email;
    state.password = signupData.password;
    state.firstName = signupData.firstName;
    state.lastName = signupData.lastName;


    startCountdown();
};







const openVerificationLinkSentDialog = () => {
    dialogVisible.value = true;
};





// listen for events
onMounted(() => {
    authEvents.on('signup-verification-email-sent', signupVerificationEmailSent);
});
// remove event listener and clear interval
onUnmounted(() => {
    authEvents.off('signup-verification-email-sent', signupVerificationEmailSent);
    clearInterval(countdownInterval);
});

</script>